import {
  anInsightResolution,
  InsightResolution,
  mockSingleInsightResolutionQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockSingleInsightResolutionQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      const insightResolutionOverrides: Partial<InsightResolution> = {
        subResolutions: [anInsightResolution()],
      };

      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insightResolution: anInsightResolution(insightResolutionOverrides),
        },
      });
    }
  ),
];
